export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">关于我们</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              老子影视网是一个专注<strong>高清电影</strong>与<strong>高清电视剧</strong>免费在线观看的影视平台。
              我们致力于为影迷提供<strong>超清画质</strong>、<strong>不缓冲秒开</strong>的极致观影体验，覆盖动作、喜剧、悬疑、
              爱情、科幻、战争、动画等全类型<strong>高清视频</strong>资源。平台每日更新热播内容，支持<strong>全集播放</strong>，
              无论是最新院线大片还是经典口碑好剧，都能在这里找到。无需注册登录，打开即看，畅享流畅观影时光。
            </p>
            <p>
              从热门榜单到专题合集，从影视资讯到用户口碑，老子影视网持续优化内容推荐，
              让每一位影迷都能快速发现心仪的高清影视作品，打造属于你的私人影院。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { num: '10万+', label: '影视资源' },
              { num: '4K', label: '超清画质' },
              { num: '99.9%', label: '播放成功率' },
              { num: '500万+', label: '月活用户' },
            ].map((s) => (
              <div key={s.label} className="p-4 rounded-lg bg-background-100 border border-background-200/60">
                <div className="text-xl md:text-2xl font-bold text-primary-500">{s.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}